<template>
  <div class="container">
    <img
      :src="getAssetImageUrl('common/logos/logo-sconchat-full.png')"
      alt="logo-sconai"
      class="logo-sconai"
    />
    <p>
      {{ t('alert_exceeded_max_participants') }}
      <br />
      {{ t('alert_thank_you_using_sconchat') }}
    </p>
    <div class="info-sconai">
      <p class="smaller">Provided with</p>
      <p class="smaller-semibold">SconAI</p>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n';

import { getAssetImageUrl } from '@/utils/getAssetImageUrl';

const { t } = useI18n();
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 30rem;
  height: calc(100dvh);
  justify-content: center;
  align-items: center;
  text-align: center;
  margin: auto;
  padding: 2rem;
  padding-bottom: 4rem;
  gap: 2rem;
}

.info-sconai {
  display: flex;
  gap: 0.2rem;
  color: var(--font-dim);
  text-wrap: nowrap;
}

.logo-sconai {
  width: 12rem;
}
</style>
